/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_For_JobInputs */

const en_apply_for_job = /** @type {(inputs: Apply_For_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply for Job`)
};

const de_apply_for_job = /** @type {(inputs: Apply_For_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Stelle bewerben`)
};

/**
* | output |
* | --- |
* | "Apply for Job" |
*
* @param {Apply_For_JobInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const apply_for_job = /** @type {((inputs?: Apply_For_JobInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_For_JobInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_apply_for_job(inputs)
	return en_apply_for_job(inputs)
});